import { useTranslation } from 'react-i18next';

/* ===========================================================================
 * WHO BUILT THIS — one sentence, and now in two places that never overlap.
 *
 * It was the page footer, on every screen at every width. On a phone that put
 * a vendor credit in the last band above the bottom navigation of a screen
 * whose whole job is one button, and the reference has it on none of the ten
 * drawings — it is in the DRAWER, on the note that says so in as many words:
 * "This is where the footer went — and where the build stamp already lived."
 *
 * So the line itself lives here, and the two callers decide WHERE: the page
 * footer above `md`, the foot of the phone's profile page below it. One of the two renders, never
 * both, which is why this is a component and not two copies of a link.
 * ======================================================================== */

/** Who built this. */
const VENDOR_URL = 'https://araneae.net';

const LINK =
  'inline-flex items-center gap-1.5 rounded-xs underline decoration-border underline-offset-2 ' +
  'transition-colors duration-fast ease-standard hover:text-foreground hover:decoration-current ' +
  'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring';

export function VendorCredit({ className }: { className?: string }): JSX.Element {
  const { t } = useTranslation();
  return (
    <span className={className}>
      {t('common.developedByPrefix', 'Developed by')}{' '}
      {/* `rel="noreferrer"` — it is the one outbound link in the product. */}
      <a className={LINK} href={VENDOR_URL} target="_blank" rel="noreferrer">
        araneae.net
      </a>
    </span>
  );
}
